
<form [formGroup]="Form" class="inline-form">
    <enterprise-text-input  [Label]="Label"
                            [formControlName]="FormControlName"
                            class="inline-form-input"
                            [Appearance]="'outline'"
                            ButtonIcon="phone"
                            ErrorMessageOverride="{{SetErrorTooltipMessage()}}"
                            [Mask]="PhoneFormat"
                            [ButtonDisabled]="ButtonDisabled"
                            [ShowButton]="ShowButton"
                            [InputId]="InputId"
                            [InputName]="InputName">
    </enterprise-text-input>
</form>
